export const IMPORT_GET_CUSTOM_FIELDS_REQUEST = "IMPORT_GET_CUSTOM_FIELDS_REQUEST"
export const IMPORT_GET_CUSTOM_FIELDS_SUCCESS = "IMPORT_GET_CUSTOM_FIELDS_SUCCESS"
export const IMPORT_GET_CUSTOM_FIELDS_FAIL = "IMPORT_GET_CUSTOM_FIELDS_FAIL"
